module.exports = __webpack_public_path__ + "img/0Q3C0560_FoamcoreMatted.1fb0e9d9.jpg";